import { objectOf } from 'prop-types';
import React, { useState } from 'react';

import Tabs from '@features/trend-research/components/details/components/Tabs';

const CategoryItems = ({ items = {} }) => {
	const [activeTab] = useState(0);

	const transformedItems = Object.keys(items).map((key) => ({
		name: key,
		count: items[key]
	}));

	return (
		<div className="category-items mb-3 d-flex flex-wrap justify-content-center align-items-center">
			<Tabs tabs={transformedItems} activeTab={activeTab} additionalClasses="p-0" />
		</div>
	);
};

CategoryItems.propTypes = {
	items: objectOf.isRequired
};

export default CategoryItems;
